import React, { memo } from 'react';

import { PageLoadEnd } from '@confluence/browser-metrics/entry-points/PageLoadEnd.ts';

import { ADVANCED_SEARCH_PAGE_LOAD, UNIFIED_SEARCH_PAGE_LOAD } from './perf.config.ts';

export const PageLoadEndEvent = memo(() => <PageLoadEnd metric={ADVANCED_SEARCH_PAGE_LOAD} />);

export const PageLoadEndEventUnifiedSearch = memo(() => (
	<PageLoadEnd metric={UNIFIED_SEARCH_PAGE_LOAD} />
));
